import { NgModule } from '@angular/core'
import { SignOutCommand } from './sign-out.command'
import { SignOutService } from './sign-out.service'

export { SignOutService }

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [SignOutCommand, SignOutService],
})
export class SignOutServiceModule {}
